<template>
    <div class="scc-container">
        <div class="scc-container__row">
            <div class="scc-container__column scc-container__lg-column--8 scc-container__column--align-right">
                <div class="scc-cta-box">
                    <div class="scc-cta-box__left" :class="`scc-cta-box__left--${backgroundColor}`">
                        <img v-if="icon" :src="icon" alt="icon" class="scc-cta-box__icon" />
                        <div class="scc-cta-box__title-container">
                            <p class="scc-cta-box__title h4">{{ title }}</p>
                        </div>
                    </div>
                    <div class="scc-cta-box__right">
                        <div class="scc-cta-box__text-container">
                            <p class="scc-cta-box__text">{{ text }}</p>
                            <SccLink class="scc-cta-box__button" button large color="primary" to="aanmelden">
                                {{ buttonText }}
                            </SccLink>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import './cta-box.scss';
import SccLink from './SccLink';

export default {
    name: 'CtaBox',
    components: { SccLink },
    __editor: {
        fields: {
            icon: {
                widget: 'media',
            },
        },
    },
    props: {
        title: {
            type: String,
            default: 'Doe mee en maak kans',
        },
        icon: String,
        text: {
            type: String,
            default:
                'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam quis fermentum velit, non molestie ante. Vivamus at sem id lorem ullamcorper sagittis. ',
        },
        buttonText: {
            type: String,
            default: 'Ik wil meedoen',
        },
        backgroundColor: {
            type: String,
            required: false,
            default: 'primary',
            validator: function(val) {
                return ['primary', 'secondary'].includes(val);
            },
        },
    },
};
</script>
